import { useCallback } from 'react';
import { useTranslations } from 'next-intl';
import { useMainContentTabs } from '../../../store/layoutStore';
import { useProjectStore } from '../../../store/projectStore';

const WELCOME_TAB_ID = 'welcome';

export function useReturnToWelcomeAfterTargetDelete() {
  const tLayout = useTranslations('layout');
  const clearTargetSelection = useProjectStore(
    (state) => state.clearTargetSelection,
  );
  const { activeTabId, openTab, closeTab } = useMainContentTabs();

  return useCallback(() => {
    const deletedTargetSettingsTabId = activeTabId;

    clearTargetSelection();
    openTab({
      id: WELCOME_TAB_ID,
      title: tLayout('welcome'),
      type: 'welcome',
    });

    if (
      deletedTargetSettingsTabId &&
      deletedTargetSettingsTabId !== WELCOME_TAB_ID
    ) {
      closeTab(deletedTargetSettingsTabId);
    }
  }, [activeTabId, clearTargetSelection, closeTab, openTab, tLayout]);
}
